<template>
    <card>
        <card-header>
            {{ title }}
        </card-header>
        <card-body class="pt-0" v-if="loading">
            <card-spinner style="height: 240px;"/>
        </card-body>
        <card-body class="pt-0 inside-trending" v-if="!loading">
            <div class="d-flex flex-row align-items-center mb-2">
                <h1 class="mr-3 main-score text-center"
                    :class="{'text-primary': avg_positive, 'text-danger': !avg_positive}">
                    {{ trends.overall.avgScore | oneDecimal }}
                </h1>
                <div class="d-flex flex-column">
                    <div>
                        <i class="fas fa-caret-up mr-1 fa-fw text-success" v-if="trends.overall.hasIncreased"></i>
                        <i class="fas fa-caret-down mr-1 fa-fw text-danger" v-if="!trends.overall.hasIncreased"></i>
                        <span class="small font-weight-bold">
                            {{ trends.overall.fromLastMonth | percentage | oneDecimal }}% from last month
                        </span>
                    </div>
                    <div class="ml-4 small font-weight-bold">
                        {{ trends.overall.totalReviews }} total reviews
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-2">
                <div>
                    <span>This month</span><span class="text-muted ml-1">({{ trends.thisMonth.totalReviews }})</span>
                </div>
                <span class="col-2 badge badge-pill"
                    :class="{'badge-primary': this_month_positive, 'badge-danger': !this_month_positive}">
                    {{ trends.thisMonth.avgScore | oneDecimal }}
                </span>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-2">
                <div>
                    <span>Last month</span><span class="text-muted ml-1">({{ trends.lastMonth.totalReviews }})</span>
                </div>
                <span class="col-2 badge badge-pill"
                    :class="{'badge-primary': last_month_positive, 'badge-danger': !last_month_positive}">
                    {{ trends.lastMonth.avgScore | oneDecimal }}
                </span>
            </div>
            <div class="d-flex justify-content-between align-items-center mb-2">
                <div>
                    <span>This year</span><span class="text-muted ml-1">({{ trends.thisYear.totalReviews }})</span>
                </div>
                <span class="col-2 badge badge-pill"
                    :class="{'badge-primary': this_year_positive, 'badge-danger': !this_year_positive}">
                    {{ trends.thisYear.avgScore | oneDecimal }}
                </span>
            </div>
        </card-body>
    </card>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        props: {
            type : {default: 'public'},
            title: {default: 'Overall Score'},
        },

        data() {
            return {
                loading: true,
                trends : {
                    overall  : {},
                    thisMonth: {},
                    lastMonth: {},
                    thisYear : {},
                }
            };
        },

        created() {
            this.fetchTrending();
        },

        watch: {
            filter() {
                this.fetchTrending();
            },
        },

        computed: {
            ...mapState(['filter']),
            avg_positive() {
                return this.trends.overall.avgScore >= 0
            },
            this_month_positive() {
                return this.trends.thisMonth.avgScore >= 0
            },
            last_month_positive() {
                return this.trends.lastMonth.avgScore >= 0
            },
            this_year_positive() {
                return this.trends.thisYear.avgScore >= 0
            },
        },

        filters: {
            oneDecimal(value) {
                const rounded = _.round(value, 1);

                if (_.isInteger(rounded)) {
                    return `${rounded}.0`
                }

                return rounded;
            },

            percentage(value) {
                return Math.abs(value) * 100
            },
        },

        methods: {
            fetchTrending() {
                this.loading = true;
                const params = {...this.filter, type: this.type, interval: 'yearly'};

                return this.$http.get(this.$laroute.route('api.reviews.trending'), {params})
                    .then(({data}) => this.trends = data)
                    .then(() => this.loading = false);
            },
        }
    }
</script>

<style lang="scss" scoped>
    .main-score {
        font-size: 4rem;
    }
</style>